import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditNgWord extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ngWord: {},
        }
        this.saveData = this.saveData.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }
    
    /**
     * Init data
     */
    componentWillMount() {
        if (this.props.match.params.hasOwnProperty('id')) {
            const ngWordId = this.props.match.params.id;
            axios.get('/api/ngwords/' + ngWordId).then(response => {
                this.setData(response.data);
            }).catch(() => {
                this.props.history.push('/_404');
            })
        }
    }
    
    /**
     * Set data of word
     * data: Object NgWord
     */
    setData(data) {
        this.setState({
            ngWord: data
        })
    }
    
    /**
     * Get data of ngWord
     */
    getData() {
        return this.state.ngWord;
    }
    
    /**
     * Call function save data from element parent
     */
    saveData() {
        let ngWord = this.getData();
        //to top
        window.scrollTo(0, 0)
        axios.put('/api/ngwords/edit/' + ngWord.id, ngWord).then(response => {
            if (response.data.hasOwnProperty('success') && response.data.success) {
                toast.success(response.data.message)
            } else if (response.data.error) {
                toast.error(response.data.message);
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                        if($.isArray(response.data.errors[key])){
                            response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(response.data.errors[key])
                        }
                    }
                )
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                    if($.isArray(error.response.data.errors[key])){
                        error.response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(error.response.data.errors[key])
                    }
                }
            )
        })
    }
    
    /**
     * Listen change input
     * event: Object input
     */
    handleInptChange(event) {
        let ngWordData = Object.assign({}, this.state.ngWord);
        ngWordData[event.target.name] = event.target.value;
        this.setState({ngWord: ngWordData});
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/ngwords">NGワード一覧</a></li>
                                <li className="breadcrumb-item active" aria-current="page">NGワード編集</li>
                            </ol>
                        </nav>
                    </div>
		</div>
		<main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                            <div className="card mb-3">
                                <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">NGワード編集</h4></div>
                                    <div className="card-body">
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">NGワード</label>
                                            <div className="col-sm-8">
                                                <input type="text" value={this.state.ngWord.word ? this.state.ngWord.word : ''} name='word' onChange={this.handleInptChange} className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                <div className="card-footer text-center">
                                    <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg"><span className="size-inherit">保存</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
